<template>
  <div>
    <PageHeader />

    <PaymentGatewayConfigModal v-if="$allowPermission('agent:manage.bank-account')" :id="settingId" @onUpdate="fetchData" />
    <PaymentGatewayBalanceModal v-if="$allowPermission('agent:manage.bank-account')" :gateway="balanceGateway" @onUpdate="fetchData" />
    <PaymentGatewayFilter @submit="onSubmitFilter" />
    <hr />
    <b-card v-if="isFetching" class="text-center py-2">
      <b-spinner />
    </b-card>
    <template v-else>
      <PaymentGatewayStatistic :balance="total.balance" :deposit="total.deposit" :deposit-count="total.depositCount" :withdraw="total.withdraw" :withdraw-count="total.withdrawCount" class="mt-4" title="ภาพรวม" />
      <hr />
      <div v-if="isMaster">
        <b-tabs>
          <b-tab v-for="agentName in agentList" :key="agentName" :title="agentName">
            <PaymentGatewayStatistic
                :balance="agentTotalSummary[agentName].balance"
                :deposit="agentTotalSummary[agentName].deposit"
                :deposit-count="agentTotalSummary[agentName].depositCount"
                :title="`ภาพรวม ${agentName}`"
                :withdraw="agentTotalSummary[agentName].withdraw" :withdraw-count="agentTotalSummary[agentName].withdrawCount"
                class="mt-4" />
            <PaymentGatewayProviderStatistic
                v-for="(summary, i) in paymentGatewaySummaries.filter(s => s.agentName === agentName)"
                :key="i"
                :summary="summary"
                class="mt-4"
                @onClickBalance="onClickBalance"
                @onClickSetting="onClickSetting"
            />
          </b-tab>
        </b-tabs>
      </div>
      <template v-else>
        <PaymentGatewayProviderStatistic
            v-for="(summary, i) in paymentGatewaySummaries"
            :key="i"
            :summary="summary"
            class="mt-4"
            @onClickBalance="onClickBalance"
            @onClickSetting="onClickSetting"
        />
      </template>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';


export default {
  name: 'PaymentGatewayDetail',
  page: {
    title: 'จัดการ Payment Gateway',
  },
  components: {
    PaymentGatewayFilter: () => import('@components/payment-gateway/filter'),
    PaymentGatewayStatistic: () => import('@components/payment-gateway/statistic'),
    PaymentGatewayProviderStatistic: () => import('@components/payment-gateway/provider-statistic'),
    PaymentGatewayConfigModal: () => import('@components/payment-gateway/payment-gateway-config-modal'),
    PaymentGatewayBalanceModal: () => import('@components/payment-gateway/payment-gateway-balance-modal'),
  },
  data() {
    return {
      from: new Date(),
      to: new Date(),
      isFetching: false,
      settingId: null,
      balanceGateway: null
    }
  },
  computed: {
    ...mapGetters(['isMaster']),
    ...mapState({
      paymentGatewaySummaries: (state) => state['payment-gateway'].paymentGatewaySummaries,
    }),
    total() {
      return this.paymentGatewaySummaries.reduce((prev, curr) => {
        return {
          deposit: curr.totalDeposit + prev.deposit,
          withdraw: curr.totalWithdraw + prev.withdraw,
          depositCount: curr.depositCount + prev.depositCount,
          withdrawCount: curr.withdrawCount + prev.withdrawCount,
          balance: curr.balance + prev.balance,
        }
      }, { deposit: 0, withdraw: 0, depositCount: 0, withdrawCount: 0, balance: 0 })
    },
    agentTotalSummary() {
      return this.paymentGatewaySummaries.reduce((prev, curr) => {
        const agentTotal = prev[curr.agentName] || { deposit: 0, withdraw: 0, depositCount: 0, withdrawCount: 0, balance: 0 }
        prev[curr.agentName] = {
          deposit: agentTotal.deposit + curr.totalDeposit,
          withdraw: agentTotal.withdraw + curr.totalWithdraw,
          depositCount: agentTotal.depositCount + curr.depositCount,
          withdrawCount: agentTotal.withdrawCount + curr.withdrawCount,
          balance: agentTotal.balance + curr.balance,
        }
        return prev
      }, {})
    },
    agentList() {
      const agents = this.paymentGatewaySummaries.map((summary) => summary.agentName)
      return [...new Set(agents)]
    }
  },
  created() {
    this.fetchData()
    setTimeout(() => {
      this.$bvModal
    })
  },
  methods: {
    ...mapActions(['getPaymentGatewaySummaries']),
    onSubmitFilter({ from, to }) {
      this.from = from;
      this.to = to;
      this.fetchData()
    },
    async fetchData() {
      this.isFetching = true;
      await this.getPaymentGatewaySummaries({
        from: this.from,
        to: this.to,
      })
      this.isFetching = false
    },
    onClickSetting(id) {
      this.settingId = id
      this.$nextTick(() => {
        this.$bvModal.show('payment-gateway-config-modal')
      })
    },
    onClickBalance(summary) {
      this.balanceGateway = summary
      this.$nextTick(() => {
        this.$bvModal.show('payment-gateway-balance-modal')
      })
    },
  }
}
</script>